import React from 'react';
import { createRoot } from 'react-dom/client';
import { Button, Modal } from 'react-bootstrap';

/*
 * Conferma prima di rimuovere o cancellare un contenuto (set-ui/regole/conferma-rimozione.md).
 * Si usa dove non c'e' gia' una finestra di conferma propria:
 *   if (await chiediConferma({ titolo: 'Togliere la riga?', testo: 'La riga sparisce dal modulo.' })) rimuovi();
 * Risponde true solo con «Rimuovi» (o l'etichetta data in `conferma`); Annulla, X, Esc e clic fuori rispondono false.
 */
export const chiediConferma = ({ titolo = 'Rimuovere?', testo = '', conferma = 'Rimuovi', variante = 'danger' } = {}) =>
    new Promise((resolve) => {
        const nodo = document.createElement('div');
        document.body.appendChild(nodo);
        const root = createRoot(nodo);
        const chiudi = (esito) => {
            root.unmount();
            nodo.remove();
            resolve(esito);
        };
        root.render(
            <Modal show centered onHide={() => chiudi(false)}>
                <Modal.Header closeButton><Modal.Title>{titolo}</Modal.Title></Modal.Header>
                {testo && <Modal.Body>{testo}</Modal.Body>}
                <Modal.Footer className="justify-content-center sid-footer-conferma">
                    <Button className="btn btn-light btn-add" onClick={() => chiudi(false)}>Annulla</Button>
                    <Button className={`btn btn-${variante} btn-add`} onClick={() => chiudi(true)}>{conferma}</Button>
                </Modal.Footer>
            </Modal>,
        );
    });

export default chiediConferma;
